/**
 * RESPONSIBILITY: a sermon's date, in words — "October 12, 2026".
 */
import { localDay } from '../commons/local-day';

const FORMAT = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

export function sermonDay(iso: string | undefined): string {
  const day = localDay(iso);
  return day ? FORMAT.format(day) : '';
}

/**
 * What to call a sermon that has no title yet (R31): its date, so a half-entered row is
 * still a named link and a named page rather than an empty heading.
 */
export const sermonName = (s: { title?: string; preachedOn?: string }): string =>
  s.title?.trim() || sermonDay(s.preachedOn);
